import { createStore, applyMiddleware } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import createSagaMiddleware from 'redux-saga'
import { all } from 'redux-saga/effects'

import reducer from './reducers'

import { watchApplicationSaga } from './app'
import { watchAuthenSaga } from './authen'
import { watchRoleManSaga } from './roleMan'
import { watchProductSaga } from './product'
import { watchPurchaseRequisitionSaga } from './purchaseRequisition'
import { watchRFQSaga } from './rfq'
import { watchGoodsServiceReceiptSaga } from './goodsServiceReceipt'
import { watchPurchaseOrderSaga } from './purchaseOrder'
import { watchContractSaga } from './contract'
import { watchOptionsSaga } from './options'
import { watchMembersSaga } from './member'
import { watchGoaSaga } from './goa'
import { watchWorkListSaga } from './workList'
import { watchMappingDataSaga } from './mappingData'
import { watchDownPaymentSaga } from './downPayment'
import { watchBillformSaga} from './billform'
import { watchQrSaga } from './qr'
import { watchPOUpdateSaga } from './poUpdate'
import { watchTrackingSaga } from './tracking'
import { watchVendorMaintenanceSaga } from './vendorMaintenance'
import { watchSupplierSaga } from './supplier'
import { watchAddressSaga } from './address'
import { watchReportSaga } from './report'
import { watchSupportSaga } from './support'
import { watchSystemSaga } from './system'
import { watchDataManagementSaga } from './dataManagement'
import { watchShortListSaga } from './shortList'
import { watchCodeOfConductSaga } from './codeOfConduct'
import { watchBankGuaranteeSaga } from './bankGuarantee'
import { watchBGRequestSaga } from './bankGuaranteeRequest'
import { watchBGCompanyRequestSaga } from './bgCompanyRequest'
import { watchBGCompanySaga } from './bgCompany'
import { watchBGLimitOfBankSaga } from './bgLimitOfBank'

export const configureStore = initialState => {
  const saga = createSagaMiddleware()
  const middlewares = [saga]

  const enhancers = [
    applyMiddleware(...middlewares)
  ]

  const store = createStore(reducer, initialState, composeWithDevTools(...enhancers))

  function* rootSaga() {
    yield all([
      watchApplicationSaga(),
      watchRoleManSaga(),
      watchAuthenSaga(),
      watchProductSaga(),
      watchPurchaseRequisitionSaga(),
      watchRFQSaga(),
      watchPurchaseOrderSaga(),
      watchGoodsServiceReceiptSaga(),
      watchContractSaga(),
      watchOptionsSaga(),
      watchMembersSaga(),
      watchGoaSaga(),
      watchWorkListSaga(),
      watchMappingDataSaga(),
      watchDownPaymentSaga(),
      watchBillformSaga(),
      watchQrSaga(),
      watchPOUpdateSaga(),
      watchTrackingSaga(),
      watchVendorMaintenanceSaga(),
      watchSupplierSaga(),
      watchAddressSaga(),
      watchReportSaga(),
      watchSupportSaga(),
      watchSystemSaga(),
      watchDataManagementSaga(),
      watchShortListSaga(),
      watchCodeOfConductSaga(),
      watchBankGuaranteeSaga(),
      watchBGRequestSaga(),
      watchBGCompanyRequestSaga(),
      watchBGCompanySaga(),
      watchBGLimitOfBankSaga()
    ])
  }
  saga.run(rootSaga)

  if (module.hot) {
    module.hot.accept('./reducers', () => store.replaceReducer(reducer))
  }

  return store
}

export default configureStore({})